import { defineMessages } from "./define";

export const marketMessages = defineMessages({
  ru: {
    "market.favourites_title": "Избранное",
    "market.favourites_empty": "Добавляйте NFT в избранное на странице токена — они появятся здесь.",
    "market.auction_active_purchase": "Этот NFT участвует в аукционе. Обычная покупка недоступна.",
    "market.ach_auction_title": "Победы на аукционах: {count}",
    "market.ach_auction_desc": "Выиграйте аукционы: {count}.",
    "market.ach_auction_source": "Достижения рассчитаны по последним 20 завершённым аукционам, доступным через API.",

    "market.preview_unavailable": "Ставки недоступны",

    "market.ranking_name": "По названию",
    "market.chart_old_record": "Последняя запись старше суток. Это не текущая котировка.",
    "market.chart_source": "Источник: история цен NFT из API Fexsea.",
    "market.chart_snapshot": "История цен на момент загрузки страницы.",
    "market.chart_current_price": "Текущая цена: {amount}. Последняя запись истории может отличаться от текущей цены.",
    "market.chart_last_record": "Последняя запись: {time}",
    "market.chart_period_empty": "В выбранном периоде нет записей.",
    "market.chart_invalid_time": "Нет цен с корректной датой.",
    "market.ranking_trending": "В тренде",
    "market.ranking_volume": "Топ по объёму",
    "market.ranking_gainers": "Растущие",
    "market.ranking_new": "Новые",
    "market.time_expired": "истекло",
    "market.time_days_hours": "{days}д {hours}ч",
    "market.time_hours_minutes": "{hours}ч {minutes}м",
    "market.time_minutes": "{minutes}м",
    "market.time_under_minute": "меньше минуты",
    "market.rarity_legendary": "Легендарный",
    "market.rarity_epic": "Эпический",
    "market.rarity_rare": "Редкий",
    "market.rarity_uncommon": "Необычный",
    "market.rarity_common": "Обычный",
    "market.ach_first_nft_title": "Первый NFT",
    "market.ach_first_nft_desc": "Купите свой первый NFT",
    "market.ach_collector_title": "Коллекционер",
    "market.ach_collector_desc": "Соберите 10 NFT в портфеле",
    "market.ach_curator_title": "Куратор",
    "market.ach_curator_desc": "Соберите 50 NFT в портфеле",
    "market.ach_trader_title": "Трейдер",
    "market.ach_whale_title": "Кит",
    "market.ach_turnover_desc": "Достигните оборота {amount}",
    "market.ach_level5_title": "Уровень 5",
    "market.ach_level5_desc": "Поднимитесь до 5 уровня",
    "market.ach_verified_title": "Проверенный",
    "market.ach_verified_desc": "Пройдите верификацию аккаунта",
    "market.ach_secure_title": "Под защитой",
    "market.ach_secure_desc": "Включите двухфакторную защиту",
    "market.phase_ended": "аукцион завершён",
    "market.phase_starts_in": "начнётся через {time}",
    "market.phase_soon": "скоро начнётся",
    "market.phase_left": "осталось {time}",
    "market.fact_token_id": "Токен ID",
    "market.fact_blockchain": "Блокчейн",
    "market.fact_contract": "Адрес контракта",
    "market.fact_rarity_rank": "Ранг редкости",
    "market.fact_rarity_rank_of": "#{rank} из {supply}",
    "market.fact_rarity_score": "Индекс редкости",
    "market.facts_unavailable": "Дополнительные сведения об NFT пока недоступны.",
    "market.traits": "Атрибуты",
    "market.trait_fallback": "Атрибут",
    "market.trait_share": "{percent} имеют этот атрибут",
    "market.standing_lead": "Ваша ставка лидирует",
    "market.standing_outbid": "Вашу ставку перебили",
    "market.auctions_server_unavailable": "Этот аукцион сейчас недоступен.",
    "market.bid_required": "Укажите сумму ставки.",
    "market.bid_min_error": "Минимальная ставка — {amount}.",
    "market.bid_accepted": "Ставка {amount} принята.",
    "market.auction": "Аукцион",
    "market.current_bid": "Текущая ставка",
    "market.start_price": "Стартовая цена",
    "market.min_bid": "Мин. ставка",
    "market.bids_count": "Ставок",
    "market.buy_now": "Выкуп сразу",
    "market.your_bid_label": "Ваша ставка, {currency}",
    "market.bid_min_hint": "Минимум {amount}",
    "market.place_bid": "Сделать ставку",
    "market.buy_now_for": "Выкупить сразу за {amount}",
    "market.buy_now_confirm_title": "Выкупить лот сразу?",
    "market.buy_now_confirm_desc": "С баланса будет списано {amount}, аукцион завершится, а NFT станет вашим.",
    "market.buy_now_confirm": "Выкупить",
    "market.buy_now_done": "Лот выкуплен.",
    "market.stats_region": "Статистика коллекции",
    "market.floor": "Флор-цена",
    "market.floor_hint": "Минимальная цена среди выставленных NFT",
    "market.volume": "Объём торгов",
    "market.volume_hint": "Суммарный объём продаж",
    "market.owners": "Владельцы",
    "market.listed": "В продаже",
    "market.listed_hint": "Доля NFT, выставленных на продажу",
    "market.supply": "Всего NFT",
    "market.floor_chart": "График floor price",
    "market.loading_short": "Загружаем…",
    "market.stats_unavailable": "История минимальной цены пока недоступна.",
    "market.floor_history_empty": "История floor price пока не накоплена.",
    "market.sort_default": "По умолчанию",
    "market.sort_price_asc": "Цена: сначала дешёвые",
    "market.sort_price_desc": "Цена: сначала дорогие",
    "market.sort_number_asc": "Token ID: по возрастанию",
    "market.sort_number_desc": "Token ID: по убыванию",
    "market.network_unknown": "Сеть не указана",
    "market.all_collections": "Все коллекции",
    "market.author": "Автор: {author}",
    "market.author_unknown": "не указан",
    "market.items_count": "Объектов",
    "market.you_own": "У вас",
    "market.min_price": "Минимальная цена",
    "market.max_price": "Максимальная цена",
    "market.items": "Объекты",
    "market.shown_of": "{shown} из {total}",
    "market.search_token": "Поиск по token ID",
    "market.filters": "Фильтры",
    "market.all_networks": "Все сети",
    "market.price_from": "Цена от",
    "market.price_to": "Цена до",
    "market.sort": "Сортировка",
    "market.reset_filters": "Сбросить фильтры",
    "market.nfts_not_found": "NFT не найдены",
    "market.nfts_not_found_filtered": "Измените параметры поиска или сбросьте фильтры.",
    "market.collection_empty": "В этой коллекции пока нет объектов.",
    "market.collection_activity": "Активность коллекции",
    "market.own_id_not_returned": "Не удалось подтвердить владение NFT. Обновите страницу.",
    "market.bought": "Покупка завершена.",
    "market.listed_done": "NFT выставлен на продажу.",
    "market.unlisted_done": "NFT снят с продажи.",
    "market.profile_refresh_failed": "Операция выполнена, но не удалось обновить данные профиля. Обновите страницу.",
    "market.invalid_price": "Введите корректную цену.",
    "market.fav_removed": "Удалено из избранного.",
    "market.fav_added": "Добавлено в избранное.",
    "market.loading_nft": "Загружаем NFT",
    "market.you_own_badge": "Вы владелец",
    "market.on_sale": "На продаже",
    "market.fav_remove_aria": "Удалить из избранного",
    "market.fav_add_aria": "Добавить в избранное",
    "market.fav_unavailable": "Избранное недоступно",
    "market.fav_in": "В избранном",
    "market.fav_to": "В избранное",
    "market.current_price": "Текущая цена",
    "market.sale_price": "Цена продажи",
    "market.list_for_sale": "Выставить на продажу",
    "market.unlist": "Снять с продажи",
    "market.own_id_missing": "Не удалось получить идентификатор владения для этой операции.",
    "market.buy_for": "Купить за {amount}",
    "market.not_for_sale": "NFT сейчас не выставлен на продажу.",
    "market.confirm_region": "Подтверждение операции",
    "market.confirm_buy": "Подтвердите покупку",
    "market.confirm_list": "Подтвердите размещение",
    "market.confirm_unlist": "Снять NFT с продажи?",
    "market.network_unknown_inline": "сеть не указана",
    "market.executing": "Выполняем…",
    "market.confirm": "Подтвердить",
    "market.cancel": "Отмена",
    "market.price_history": "История цены",
    "market.price_history_chart": "График истории цены",
    "market.price_history_empty": "История цены пока недоступна.",
    "market.nft_activity": "Активность NFT",
    "market.loading_collections": "Загружаем коллекции",
    "market.network": "Сеть",
    "market.all": "Все",
    "market.no_collections": "Коллекций пока нет",
    "market.no_collections_desc": "Новые коллекции появятся здесь после публикации.",
    "market.by_author": "Автор {author}",
    "market.collections_list": "Список коллекций",
    "market.collection": "Коллекция",
    "market.search_aria": "Поиск по маркетплейсу",
    "market.search_clear": "Очистить поиск",
    "market.search_results": "Результаты поиска",
    "market.collections": "Коллекции",
    "market.searching": "Ищем",
    "market.nothing_found": "Ничего не найдено",
    "market.status_active": "Идут сейчас",
    "market.status_active_empty": "Активных аукционов сейчас нет.",
    "market.status_upcoming": "Скоро",
    "market.status_upcoming_empty": "Ближайших аукционов пока нет.",
    "market.status_ended": "Завершённые",
    "market.status_ended_empty": "Завершённых аукционов пока нет.",
    "market.auctions_eyebrow": "Торги",
    "market.auctions_title": "Аукционы",
    "market.auctions_subtitle": "Делайте ставки на лоты платформы",
    "market.auctions_status_aria": "Статус аукционов",
    "market.loading_auctions": "Загружаем аукционы",
    "market.auctions_unavailable_note": "Аукционов пока нет.",
    "market.empty": "Пусто",
    "market.card_bid": "Ставка",
    "market.card_start": "Старт",
    "market.card_buyout": "Выкуп",
    "market.rankings_eyebrow": "Статистика",
    "market.rankings_title": "Рейтинги",
    "market.rankings_subtitle": "Коллекции площадки",
    "market.category_aria": "Категория",
    "market.period_aria": "Период",
    "market.rankings_unavailable": "Торговая статистика рейтинга недоступна. Показан каталог коллекций.",
    "market.loading_ranking": "Загружаем рейтинг",
    "market.rankings_empty_title": "Пока пусто",
    "market.rankings_empty_desc": "Нет коллекций для отображения.",
    "market.col_floor": "Мин. цена",
    "market.col_volume": "Объём",
    "market.col_change": "Изменение",
    "market.chart_insufficient": "Недостаточно данных для графика.",
    "market.chart_min": "мин. {value}",
    "market.chart_max": "макс. {value}",
    "market.period_1H": "1 ч",
    "market.period_6H": "6 ч",
    "market.period_24H": "24 ч",
    "market.period_7D": "7 д",
    "market.period_30D": "30 д"
  },
  en: {
    "market.favourites_title": "Favourites",
    "market.favourites_empty": "Save NFTs from their token page to see them here.",
    "market.auction_active_purchase": "This NFT is in an auction. Regular purchase is unavailable.",
    "market.ach_auction_title": "Auction wins: {count}",
    "market.ach_auction_desc": "Win {count} auctions.",
    "market.ach_auction_source": "Achievements use the latest 20 completed auctions available through the API.",

    "market.preview_unavailable": "Bidding unavailable",

    "market.ranking_name": "By name",
    "market.chart_old_record": "The last record is over a day old. It is not a current quote.",
    "market.chart_source": "Source: NFT price history from the Fexsea API.",
    "market.chart_snapshot": "Price history as of page load.",
    "market.chart_current_price": "Current price: {amount}. The last history record can differ from the current price.",
    "market.chart_last_record": "Last record: {time}",
    "market.chart_period_empty": "No records in the selected period.",
    "market.chart_invalid_time": "No prices with valid timestamps.",
    "market.ranking_trending": "Trending",
    "market.ranking_volume": "Top by volume",
    "market.ranking_gainers": "Top gainers",
    "market.ranking_new": "New",
    "market.time_expired": "expired",
    "market.time_days_hours": "{days}d {hours}h",
    "market.time_hours_minutes": "{hours}h {minutes}m",
    "market.time_minutes": "{minutes}m",
    "market.time_under_minute": "less than a minute",
    "market.rarity_legendary": "Legendary",
    "market.rarity_epic": "Epic",
    "market.rarity_rare": "Rare",
    "market.rarity_uncommon": "Uncommon",
    "market.rarity_common": "Common",
    "market.ach_first_nft_title": "First NFT",
    "market.ach_first_nft_desc": "Buy your first NFT",
    "market.ach_collector_title": "Collector",
    "market.ach_collector_desc": "Hold 10 NFTs in your portfolio",
    "market.ach_curator_title": "Curator",
    "market.ach_curator_desc": "Hold 50 NFTs in your portfolio",
    "market.ach_trader_title": "Trader",
    "market.ach_whale_title": "Whale",
    "market.ach_turnover_desc": "Reach a turnover of {amount}",
    "market.ach_level5_title": "Level 5",
    "market.ach_level5_desc": "Reach level 5",
    "market.ach_verified_title": "Verified",
    "market.ach_verified_desc": "Verify your account",
    "market.ach_secure_title": "Protected",
    "market.ach_secure_desc": "Turn on two-factor protection",
    "market.phase_ended": "auction ended",
    "market.phase_starts_in": "starts in {time}",
    "market.phase_soon": "starting soon",
    "market.phase_left": "{time} left",
    "market.fact_token_id": "Token ID",
    "market.fact_blockchain": "Blockchain",
    "market.fact_contract": "Contract address",
    "market.fact_rarity_rank": "Rarity rank",
    "market.fact_rarity_rank_of": "#{rank} of {supply}",
    "market.fact_rarity_score": "Rarity score",
    "market.facts_unavailable": "Additional NFT details are currently unavailable.",
    "market.traits": "Traits",
    "market.trait_fallback": "Trait",
    "market.trait_share": "{percent} have this trait",
    "market.standing_lead": "Your bid is leading",
    "market.standing_outbid": "You have been outbid",
    "market.auctions_server_unavailable": "This auction is currently unavailable.",
    "market.bid_required": "Enter a bid amount.",
    "market.bid_min_error": "The minimum bid is {amount}.",
    "market.bid_accepted": "Bid of {amount} accepted.",
    "market.auction": "Auction",
    "market.current_bid": "Current bid",
    "market.start_price": "Starting price",
    "market.min_bid": "Min. bid",
    "market.bids_count": "Bids",
    "market.buy_now": "Buy now",
    "market.your_bid_label": "Your bid, {currency}",
    "market.bid_min_hint": "Minimum {amount}",
    "market.place_bid": "Place bid",
    "market.buy_now_for": "Buy now for {amount}",
    "market.buy_now_confirm_title": "Buy this lot now?",
    "market.buy_now_confirm_desc": "{amount} will be deducted from your balance, the auction will end and the NFT will be yours.",
    "market.buy_now_confirm": "Buy now",
    "market.buy_now_done": "Lot purchased.",
    "market.stats_region": "Collection statistics",
    "market.floor": "Floor price",
    "market.floor_hint": "Lowest price among listed NFTs",
    "market.volume": "Trading volume",
    "market.volume_hint": "Total sales volume",
    "market.owners": "Owners",
    "market.listed": "Listed",
    "market.listed_hint": "Share of NFTs listed for sale",
    "market.supply": "Total NFTs",
    "market.floor_chart": "Floor price chart",
    "market.loading_short": "Loading…",
    "market.stats_unavailable": "Minimum price history is currently unavailable.",
    "market.floor_history_empty": "No floor price history yet.",
    "market.sort_default": "Default",
    "market.sort_price_asc": "Price: low to high",
    "market.sort_price_desc": "Price: high to low",
    "market.sort_number_asc": "Token ID: ascending",
    "market.sort_number_desc": "Token ID: descending",
    "market.network_unknown": "Network not specified",
    "market.all_collections": "All collections",
    "market.author": "Creator: {author}",
    "market.author_unknown": "not specified",
    "market.items_count": "Items",
    "market.you_own": "You own",
    "market.min_price": "Minimum price",
    "market.max_price": "Maximum price",
    "market.items": "Items",
    "market.shown_of": "{shown} of {total}",
    "market.search_token": "Search by token ID",
    "market.filters": "Filters",
    "market.all_networks": "All networks",
    "market.price_from": "Price from",
    "market.price_to": "Price to",
    "market.sort": "Sort by",
    "market.reset_filters": "Reset filters",
    "market.nfts_not_found": "No NFTs found",
    "market.nfts_not_found_filtered": "Change your search or reset the filters.",
    "market.collection_empty": "This collection has no items yet.",
    "market.collection_activity": "Collection activity",
    "market.own_id_not_returned": "Could not confirm NFT ownership. Refresh the page.",
    "market.bought": "Purchase complete.",
    "market.listed_done": "NFT listed for sale.",
    "market.unlisted_done": "NFT removed from sale.",
    "market.profile_refresh_failed": "The operation succeeded, but your profile data couldn't be refreshed. Please reload the page.",
    "market.invalid_price": "Enter a valid price.",
    "market.fav_removed": "Removed from favourites.",
    "market.fav_added": "Added to favourites.",
    "market.loading_nft": "Loading NFT",
    "market.you_own_badge": "You own this",
    "market.on_sale": "For sale",
    "market.fav_remove_aria": "Remove from favourites",
    "market.fav_add_aria": "Add to favourites",
    "market.fav_unavailable": "Favourites unavailable",
    "market.fav_in": "In favourites",
    "market.fav_to": "Add to favourites",
    "market.current_price": "Current price",
    "market.sale_price": "Sale price",
    "market.list_for_sale": "List for sale",
    "market.unlist": "Remove from sale",
    "market.own_id_missing": "Couldn't get the ownership ID for this operation.",
    "market.buy_for": "Buy for {amount}",
    "market.not_for_sale": "This NFT is not currently for sale.",
    "market.confirm_region": "Operation confirmation",
    "market.confirm_buy": "Confirm purchase",
    "market.confirm_list": "Confirm listing",
    "market.confirm_unlist": "Remove the NFT from sale?",
    "market.network_unknown_inline": "network not specified",
    "market.executing": "Processing…",
    "market.confirm": "Confirm",
    "market.cancel": "Cancel",
    "market.price_history": "Price history",
    "market.price_history_chart": "Price history chart",
    "market.price_history_empty": "Price history is not available yet.",
    "market.nft_activity": "NFT activity",
    "market.loading_collections": "Loading collections",
    "market.network": "Network",
    "market.all": "All",
    "market.no_collections": "No collections yet",
    "market.no_collections_desc": "New collections will appear here once published.",
    "market.by_author": "By {author}",
    "market.collections_list": "Collection list",
    "market.collection": "Collection",
    "market.search_aria": "Search the marketplace",
    "market.search_clear": "Clear search",
    "market.search_results": "Search results",
    "market.collections": "Collections",
    "market.searching": "Searching",
    "market.nothing_found": "Nothing found",
    "market.status_active": "Live now",
    "market.status_active_empty": "There are no live auctions right now.",
    "market.status_upcoming": "Upcoming",
    "market.status_upcoming_empty": "No upcoming auctions yet.",
    "market.status_ended": "Ended",
    "market.status_ended_empty": "No ended auctions yet.",
    "market.auctions_eyebrow": "Auctions",
    "market.auctions_title": "Auctions",
    "market.auctions_subtitle": "Bid on platform lots",
    "market.auctions_status_aria": "Auction status",
    "market.loading_auctions": "Loading auctions",
    "market.auctions_unavailable_note": "No auctions yet.",
    "market.empty": "Empty",
    "market.card_bid": "Bid",
    "market.card_start": "Start",
    "market.card_buyout": "Buy now",
    "market.rankings_eyebrow": "Stats",
    "market.rankings_title": "Rankings",
    "market.rankings_subtitle": "Collections on the marketplace",
    "market.category_aria": "Category",
    "market.period_aria": "Period",
    "market.rankings_unavailable": "Ranking trading statistics are unavailable. Showing the collection catalogue.",
    "market.loading_ranking": "Loading rankings",
    "market.rankings_empty_title": "Nothing here yet",
    "market.rankings_empty_desc": "No collections to display.",
    "market.col_floor": "Floor",
    "market.col_volume": "Volume",
    "market.col_change": "Change",
    "market.chart_insufficient": "Not enough data for a chart.",
    "market.chart_min": "min. {value}",
    "market.chart_max": "max. {value}",
    "market.period_1H": "1H",
    "market.period_6H": "6H",
    "market.period_24H": "24H",
    "market.period_7D": "7D",
    "market.period_30D": "30D"
  },
  ua: {
    "market.favourites_title": "Обране",
    "market.favourites_empty": "Додавайте NFT до обраного на сторінці токена — вони з’являться тут.",
    "market.auction_active_purchase": "Цей NFT бере участь в аукціоні. Звичайна купівля недоступна.",
    "market.ach_auction_title": "Перемоги на аукціонах: {count}",
    "market.ach_auction_desc": "Виграйте аукціони: {count}.",
    "market.ach_auction_source": "Досягнення розраховані за останніми 20 завершеними аукціонами, доступними через API.",

    "market.preview_unavailable": "Ставки недоступні",

    "market.ranking_name": "За назвою",
    "market.chart_old_record": "Останній запис старший за добу. Це не поточне котирування.",
    "market.chart_source": "Джерело: історія цін NFT з API Fexsea.",
    "market.chart_snapshot": "Історія цін на момент завантаження сторінки.",
    "market.chart_current_price": "Поточна ціна: {amount}. Останній запис історії може відрізнятися від поточної ціни.",
    "market.chart_last_record": "Останній запис: {time}",
    "market.chart_period_empty": "У вибраному періоді немає записів.",
    "market.chart_invalid_time": "Немає цін із коректною датою.",
    "market.ranking_trending": "У тренді",
    "market.ranking_volume": "Топ за обсягом",
    "market.ranking_gainers": "Зростаючі",
    "market.ranking_new": "Нові",
    "market.time_expired": "минуло",
    "market.time_days_hours": "{days}д {hours}год",
    "market.time_hours_minutes": "{hours}год {minutes}хв",
    "market.time_minutes": "{minutes}хв",
    "market.time_under_minute": "менше хвилини",
    "market.rarity_legendary": "Легендарний",
    "market.rarity_epic": "Епічний",
    "market.rarity_rare": "Рідкісний",
    "market.rarity_uncommon": "Незвичайний",
    "market.rarity_common": "Звичайний",
    "market.ach_first_nft_title": "Перший NFT",
    "market.ach_first_nft_desc": "Купіть свій перший NFT",
    "market.ach_collector_title": "Колекціонер",
    "market.ach_collector_desc": "Зберіть 10 NFT у портфелі",
    "market.ach_curator_title": "Куратор",
    "market.ach_curator_desc": "Зберіть 50 NFT у портфелі",
    "market.ach_trader_title": "Трейдер",
    "market.ach_whale_title": "Кит",
    "market.ach_turnover_desc": "Досягніть обороту {amount}",
    "market.ach_level5_title": "Рівень 5",
    "market.ach_level5_desc": "Підніміться до 5 рівня",
    "market.ach_verified_title": "Перевірений",
    "market.ach_verified_desc": "Пройдіть верифікацію акаунта",
    "market.ach_secure_title": "Під захистом",
    "market.ach_secure_desc": "Увімкніть двофакторний захист",
    "market.phase_ended": "аукціон завершено",
    "market.phase_starts_in": "почнеться через {time}",
    "market.phase_soon": "незабаром почнеться",
    "market.phase_left": "залишилося {time}",
    "market.fact_token_id": "Токен ID",
    "market.fact_blockchain": "Блокчейн",
    "market.fact_contract": "Адреса контракту",
    "market.fact_rarity_rank": "Ранг рідкісності",
    "market.fact_rarity_rank_of": "#{rank} з {supply}",
    "market.fact_rarity_score": "Індекс рідкісності",
    "market.facts_unavailable": "Додаткові відомості про NFT наразі недоступні.",
    "market.traits": "Атрибути",
    "market.trait_fallback": "Атрибут",
    "market.trait_share": "{percent} мають цей атрибут",
    "market.standing_lead": "Ваша ставка лідирує",
    "market.standing_outbid": "Вашу ставку перебили",
    "market.auctions_server_unavailable": "Цей аукціон наразі недоступний.",
    "market.bid_required": "Вкажіть суму ставки.",
    "market.bid_min_error": "Мінімальна ставка — {amount}.",
    "market.bid_accepted": "Ставку {amount} прийнято.",
    "market.auction": "Аукціон",
    "market.current_bid": "Поточна ставка",
    "market.start_price": "Стартова ціна",
    "market.min_bid": "Мін. ставка",
    "market.bids_count": "Ставок",
    "market.buy_now": "Миттєвий викуп",
    "market.your_bid_label": "Ваша ставка, {currency}",
    "market.bid_min_hint": "Мінімум {amount}",
    "market.place_bid": "Зробити ставку",
    "market.buy_now_for": "Викупити одразу за {amount}",
    "market.buy_now_confirm_title": "Викупити лот одразу?",
    "market.buy_now_confirm_desc": "З балансу буде списано {amount}, аукціон завершиться, а NFT стане вашим.",
    "market.buy_now_confirm": "Викупити",
    "market.buy_now_done": "Лот викуплено.",
    "market.stats_region": "Статистика колекції",
    "market.floor": "Флор-ціна",
    "market.floor_hint": "Мінімальна ціна серед виставлених NFT",
    "market.volume": "Обсяг торгів",
    "market.volume_hint": "Сумарний обсяг продажів",
    "market.owners": "Власники",
    "market.listed": "У продажу",
    "market.listed_hint": "Частка NFT, виставлених на продаж",
    "market.supply": "Усього NFT",
    "market.floor_chart": "Графік floor price",
    "market.loading_short": "Завантажуємо…",
    "market.stats_unavailable": "Історія мінімальної ціни наразі недоступна.",
    "market.floor_history_empty": "Історію floor price ще не накопичено.",
    "market.sort_default": "За замовчуванням",
    "market.sort_price_asc": "Ціна: спочатку дешевші",
    "market.sort_price_desc": "Ціна: спочатку дорожчі",
    "market.sort_number_asc": "Token ID: за зростанням",
    "market.sort_number_desc": "Token ID: за спаданням",
    "market.network_unknown": "Мережу не вказано",
    "market.all_collections": "Усі колекції",
    "market.author": "Автор: {author}",
    "market.author_unknown": "не вказано",
    "market.items_count": "Об'єктів",
    "market.you_own": "У вас",
    "market.min_price": "Мінімальна ціна",
    "market.max_price": "Максимальна ціна",
    "market.items": "Об'єкти",
    "market.shown_of": "{shown} з {total}",
    "market.search_token": "Пошук за token ID",
    "market.filters": "Фільтри",
    "market.all_networks": "Усі мережі",
    "market.price_from": "Ціна від",
    "market.price_to": "Ціна до",
    "market.sort": "Сортування",
    "market.reset_filters": "Скинути фільтри",
    "market.nfts_not_found": "NFT не знайдено",
    "market.nfts_not_found_filtered": "Змініть параметри пошуку або скиньте фільтри.",
    "market.collection_empty": "У цій колекції поки немає об'єктів.",
    "market.collection_activity": "Активність колекції",
    "market.own_id_not_returned": "Не вдалося підтвердити володіння NFT. Оновіть сторінку.",
    "market.bought": "Покупку завершено.",
    "market.listed_done": "NFT виставлено на продаж.",
    "market.unlisted_done": "NFT знято з продажу.",
    "market.profile_refresh_failed": "Операцію виконано, але не вдалося оновити дані профілю. Оновіть сторінку.",
    "market.invalid_price": "Введіть коректну ціну.",
    "market.fav_removed": "Видалено з обраного.",
    "market.fav_added": "Додано до обраного.",
    "market.loading_nft": "Завантажуємо NFT",
    "market.you_own_badge": "Ви власник",
    "market.on_sale": "У продажу",
    "market.fav_remove_aria": "Видалити з обраного",
    "market.fav_add_aria": "Додати до обраного",
    "market.fav_unavailable": "Обране недоступне",
    "market.fav_in": "В обраному",
    "market.fav_to": "До обраного",
    "market.current_price": "Поточна ціна",
    "market.sale_price": "Ціна продажу",
    "market.list_for_sale": "Виставити на продаж",
    "market.unlist": "Зняти з продажу",
    "market.own_id_missing": "Не вдалося отримати ідентифікатор володіння для цієї операції.",
    "market.buy_for": "Купити за {amount}",
    "market.not_for_sale": "NFT зараз не виставлено на продаж.",
    "market.confirm_region": "Підтвердження операції",
    "market.confirm_buy": "Підтвердьте покупку",
    "market.confirm_list": "Підтвердьте розміщення",
    "market.confirm_unlist": "Зняти NFT з продажу?",
    "market.network_unknown_inline": "мережу не вказано",
    "market.executing": "Виконуємо…",
    "market.confirm": "Підтвердити",
    "market.cancel": "Скасувати",
    "market.price_history": "Історія ціни",
    "market.price_history_chart": "Графік історії ціни",
    "market.price_history_empty": "Історія ціни поки недоступна.",
    "market.nft_activity": "Активність NFT",
    "market.loading_collections": "Завантажуємо колекції",
    "market.network": "Мережа",
    "market.all": "Усі",
    "market.no_collections": "Колекцій поки немає",
    "market.no_collections_desc": "Нові колекції з'являться тут після публікації.",
    "market.by_author": "Автор {author}",
    "market.collections_list": "Список колекцій",
    "market.collection": "Колекція",
    "market.search_aria": "Пошук по маркетплейсу",
    "market.search_clear": "Очистити пошук",
    "market.search_results": "Результати пошуку",
    "market.collections": "Колекції",
    "market.searching": "Шукаємо",
    "market.nothing_found": "Нічого не знайдено",
    "market.status_active": "Тривають зараз",
    "market.status_active_empty": "Активних аукціонів зараз немає.",
    "market.status_upcoming": "Незабаром",
    "market.status_upcoming_empty": "Найближчих аукціонів поки немає.",
    "market.status_ended": "Завершені",
    "market.status_ended_empty": "Завершених аукціонів поки немає.",
    "market.auctions_eyebrow": "Торги",
    "market.auctions_title": "Аукціони",
    "market.auctions_subtitle": "Робіть ставки на лоти платформи",
    "market.auctions_status_aria": "Статус аукціонів",
    "market.loading_auctions": "Завантажуємо аукціони",
    "market.auctions_unavailable_note": "Аукціонів поки немає.",
    "market.empty": "Порожньо",
    "market.card_bid": "Ставка",
    "market.card_start": "Старт",
    "market.card_buyout": "Викуп",
    "market.rankings_eyebrow": "Статистика",
    "market.rankings_title": "Рейтинги",
    "market.rankings_subtitle": "Колекції майданчика",
    "market.category_aria": "Категорія",
    "market.period_aria": "Період",
    "market.rankings_unavailable": "Торгова статистика рейтингу недоступна. Показано каталог колекцій.",
    "market.loading_ranking": "Завантажуємо рейтинг",
    "market.rankings_empty_title": "Поки порожньо",
    "market.rankings_empty_desc": "Немає колекцій для відображення.",
    "market.col_floor": "Мін. ціна",
    "market.col_volume": "Обсяг",
    "market.col_change": "Зміна",
    "market.chart_insufficient": "Недостатньо даних для графіка.",
    "market.chart_min": "мін. {value}",
    "market.chart_max": "макс. {value}",
    "market.period_1H": "1 год",
    "market.period_6H": "6 год",
    "market.period_24H": "24 год",
    "market.period_7D": "7 дн",
    "market.period_30D": "30 дн"
  },
  bl: {
    "market.favourites_title": "Абранае",
    "market.favourites_empty": "Дадавайце NFT у абранае на старонцы токена — яны з’явяцца тут.",
    "market.auction_active_purchase": "Гэты NFT удзельнічае ў аўкцыёне. Звычайная купля недаступная.",
    "market.ach_auction_title": "Перамогі на аўкцыёнах: {count}",
    "market.ach_auction_desc": "Выйграйце аўкцыёны: {count}.",
    "market.ach_auction_source": "Дасягненні разлічаны па апошніх 20 завершаных аўкцыёнах, даступных праз API.",

    "market.preview_unavailable": "Стаўкі недаступныя",

    "market.ranking_name": "Па назве",
    "market.chart_old_record": "Апошні запіс старэйшы за суткі. Гэта не бягучая каціроўка.",
    "market.chart_source": "Крыніца: гісторыя цэн NFT з API Fexsea.",
    "market.chart_snapshot": "Гісторыя цэн на момант загрузкі старонкі.",
    "market.chart_current_price": "Бягучая цана: {amount}. Апошні запіс гісторыі можа адрознівацца ад бягучай цаны.",
    "market.chart_last_record": "Апошні запіс: {time}",
    "market.chart_period_empty": "У выбраным перыядзе няма запісаў.",
    "market.chart_invalid_time": "Няма цэн з карэктнай датай.",
    "market.ranking_trending": "У трэндзе",
    "market.ranking_volume": "Топ па аб'ёме",
    "market.ranking_gainers": "Растучыя",
    "market.ranking_new": "Новыя",
    "market.time_expired": "скончылася",
    "market.time_days_hours": "{days}д {hours}гадз",
    "market.time_hours_minutes": "{hours}гадз {minutes}хв",
    "market.time_minutes": "{minutes}хв",
    "market.time_under_minute": "менш за хвіліну",
    "market.rarity_legendary": "Легендарны",
    "market.rarity_epic": "Эпічны",
    "market.rarity_rare": "Рэдкі",
    "market.rarity_uncommon": "Незвычайны",
    "market.rarity_common": "Звычайны",
    "market.ach_first_nft_title": "Першы NFT",
    "market.ach_first_nft_desc": "Купіце свой першы NFT",
    "market.ach_collector_title": "Калекцыянер",
    "market.ach_collector_desc": "Збярыце 10 NFT у партфелі",
    "market.ach_curator_title": "Куратар",
    "market.ach_curator_desc": "Збярыце 50 NFT у партфелі",
    "market.ach_trader_title": "Трэйдар",
    "market.ach_whale_title": "Кіт",
    "market.ach_turnover_desc": "Дасягніце абароту {amount}",
    "market.ach_level5_title": "Узровень 5",
    "market.ach_level5_desc": "Падніміцеся да 5 узроўню",
    "market.ach_verified_title": "Правераны",
    "market.ach_verified_desc": "Прайдзіце верыфікацыю акаўнта",
    "market.ach_secure_title": "Пад абаронай",
    "market.ach_secure_desc": "Уключыце двухфактарную абарону",
    "market.phase_ended": "аўкцыён завершаны",
    "market.phase_starts_in": "пачнецца праз {time}",
    "market.phase_soon": "хутка пачнецца",
    "market.phase_left": "засталося {time}",
    "market.fact_token_id": "Токен ID",
    "market.fact_blockchain": "Блокчэйн",
    "market.fact_contract": "Адрас кантракта",
    "market.fact_rarity_rank": "Ранг рэдкасці",
    "market.fact_rarity_rank_of": "#{rank} з {supply}",
    "market.fact_rarity_score": "Індэкс рэдкасці",
    "market.facts_unavailable": "Дадатковыя звесткі пра NFT пакуль недаступныя.",
    "market.traits": "Атрыбуты",
    "market.trait_fallback": "Атрыбут",
    "market.trait_share": "{percent} маюць гэты атрыбут",
    "market.standing_lead": "Ваша стаўка лідзіруе",
    "market.standing_outbid": "Вашу стаўку перабілі",
    "market.auctions_server_unavailable": "Гэты аўкцыён зараз недаступны.",
    "market.bid_required": "Укажыце суму стаўкі.",
    "market.bid_min_error": "Мінімальная стаўка — {amount}.",
    "market.bid_accepted": "Стаўка {amount} прынята.",
    "market.auction": "Аўкцыён",
    "market.current_bid": "Бягучая стаўка",
    "market.start_price": "Стартавая цана",
    "market.min_bid": "Мін. стаўка",
    "market.bids_count": "Ставак",
    "market.buy_now": "Імгненны выкуп",
    "market.your_bid_label": "Ваша стаўка, {currency}",
    "market.bid_min_hint": "Мінімум {amount}",
    "market.place_bid": "Зрабіць стаўку",
    "market.buy_now_for": "Выкупіць адразу за {amount}",
    "market.buy_now_confirm_title": "Выкупіць лот адразу?",
    "market.buy_now_confirm_desc": "З балансу будзе спісана {amount}, аўкцыён завершыцца, а NFT стане вашым.",
    "market.buy_now_confirm": "Выкупіць",
    "market.buy_now_done": "Лот выкуплены.",
    "market.stats_region": "Статыстыка калекцыі",
    "market.floor": "Флор-цана",
    "market.floor_hint": "Мінімальная цана сярод выстаўленых NFT",
    "market.volume": "Аб'ём таргоў",
    "market.volume_hint": "Сумарны аб'ём продажаў",
    "market.owners": "Уладальнікі",
    "market.listed": "У продажы",
    "market.listed_hint": "Доля NFT, выстаўленых на продаж",
    "market.supply": "Усяго NFT",
    "market.floor_chart": "Графік floor price",
    "market.loading_short": "Загружаем…",
    "market.stats_unavailable": "Гісторыя мінімальнай цаны пакуль недаступная.",
    "market.floor_history_empty": "Гісторыя floor price пакуль не назапашана.",
    "market.sort_default": "Па змаўчанні",
    "market.sort_price_asc": "Цана: спачатку танныя",
    "market.sort_price_desc": "Цана: спачатку дарагія",
    "market.sort_number_asc": "Token ID: па ўзрастанні",
    "market.sort_number_desc": "Token ID: па змяншэнні",
    "market.network_unknown": "Сетка не ўказана",
    "market.all_collections": "Усе калекцыі",
    "market.author": "Аўтар: {author}",
    "market.author_unknown": "не ўказаны",
    "market.items_count": "Аб'ектаў",
    "market.you_own": "У вас",
    "market.min_price": "Мінімальная цана",
    "market.max_price": "Максімальная цана",
    "market.items": "Аб'екты",
    "market.shown_of": "{shown} з {total}",
    "market.search_token": "Пошук па token ID",
    "market.filters": "Фільтры",
    "market.all_networks": "Усе сеткі",
    "market.price_from": "Цана ад",
    "market.price_to": "Цана да",
    "market.sort": "Сартаванне",
    "market.reset_filters": "Скінуць фільтры",
    "market.nfts_not_found": "NFT не знойдзены",
    "market.nfts_not_found_filtered": "Змяніце параметры пошуку або скіньце фільтры.",
    "market.collection_empty": "У гэтай калекцыі пакуль няма аб'ектаў.",
    "market.collection_activity": "Актыўнасць калекцыі",
    "market.own_id_not_returned": "Не ўдалося пацвердзіць валоданне NFT. Абнавіце старонку.",
    "market.bought": "Пакупка завершана.",
    "market.listed_done": "NFT выстаўлены на продаж.",
    "market.unlisted_done": "NFT зняты з продажу.",
    "market.profile_refresh_failed": "Аперацыя выканана, але не ўдалося абнавіць даныя профілю. Абнавіце старонку.",
    "market.invalid_price": "Увядзіце карэктную цану.",
    "market.fav_removed": "Выдалена з абранага.",
    "market.fav_added": "Дададзена ў абранае.",
    "market.loading_nft": "Загружаем NFT",
    "market.you_own_badge": "Вы ўладальнік",
    "market.on_sale": "На продажы",
    "market.fav_remove_aria": "Выдаліць з абранага",
    "market.fav_add_aria": "Дадаць у абранае",
    "market.fav_unavailable": "Абранае недаступнае",
    "market.fav_in": "У абраным",
    "market.fav_to": "У абранае",
    "market.current_price": "Бягучая цана",
    "market.sale_price": "Цана продажу",
    "market.list_for_sale": "Выставіць на продаж",
    "market.unlist": "Зняць з продажу",
    "market.own_id_missing": "Не ўдалося атрымаць ідэнтыфікатар валодання для гэтай аперацыі.",
    "market.buy_for": "Купіць за {amount}",
    "market.not_for_sale": "NFT зараз не выстаўлены на продаж.",
    "market.confirm_region": "Пацвярджэнне аперацыі",
    "market.confirm_buy": "Пацвердзіце пакупку",
    "market.confirm_list": "Пацвердзіце размяшчэнне",
    "market.confirm_unlist": "Зняць NFT з продажу?",
    "market.network_unknown_inline": "сетка не ўказана",
    "market.executing": "Выконваем…",
    "market.confirm": "Пацвердзіць",
    "market.cancel": "Адмена",
    "market.price_history": "Гісторыя цаны",
    "market.price_history_chart": "Графік гісторыі цаны",
    "market.price_history_empty": "Гісторыя цаны пакуль недаступная.",
    "market.nft_activity": "Актыўнасць NFT",
    "market.loading_collections": "Загружаем калекцыі",
    "market.network": "Сетка",
    "market.all": "Усе",
    "market.no_collections": "Калекцый пакуль няма",
    "market.no_collections_desc": "Новыя калекцыі з'явяцца тут пасля публікацыі.",
    "market.by_author": "Аўтар {author}",
    "market.collections_list": "Спіс калекцый",
    "market.collection": "Калекцыя",
    "market.search_aria": "Пошук па маркетплейсе",
    "market.search_clear": "Ачысціць пошук",
    "market.search_results": "Вынікі пошуку",
    "market.collections": "Калекцыі",
    "market.searching": "Шукаем",
    "market.nothing_found": "Нічога не знойдзена",
    "market.status_active": "Ідуць зараз",
    "market.status_active_empty": "Актыўных аўкцыёнаў зараз няма.",
    "market.status_upcoming": "Хутка",
    "market.status_upcoming_empty": "Бліжэйшых аўкцыёнаў пакуль няма.",
    "market.status_ended": "Завершаныя",
    "market.status_ended_empty": "Завершаных аўкцыёнаў пакуль няма.",
    "market.auctions_eyebrow": "Таргі",
    "market.auctions_title": "Аўкцыёны",
    "market.auctions_subtitle": "Рабіце стаўкі на лоты платформы",
    "market.auctions_status_aria": "Статус аўкцыёнаў",
    "market.loading_auctions": "Загружаем аўкцыёны",
    "market.auctions_unavailable_note": "Аўкцыёнаў пакуль няма.",
    "market.empty": "Пуста",
    "market.card_bid": "Стаўка",
    "market.card_start": "Старт",
    "market.card_buyout": "Выкуп",
    "market.rankings_eyebrow": "Статыстыка",
    "market.rankings_title": "Рэйтынгі",
    "market.rankings_subtitle": "Калекцыі пляцоўкі",
    "market.category_aria": "Катэгорыя",
    "market.period_aria": "Перыяд",
    "market.rankings_unavailable": "Гандлёвая статыстыка рэйтынгу недаступная. Паказаны каталог калекцый.",
    "market.loading_ranking": "Загружаем рэйтынг",
    "market.rankings_empty_title": "Пакуль пуста",
    "market.rankings_empty_desc": "Няма калекцый для паказу.",
    "market.col_floor": "Мін. цана",
    "market.col_volume": "Аб'ём",
    "market.col_change": "Змяненне",
    "market.chart_insufficient": "Недастаткова даных для графіка.",
    "market.chart_min": "мін. {value}",
    "market.chart_max": "макс. {value}",
    "market.period_1H": "1 гадз",
    "market.period_6H": "6 гадз",
    "market.period_24H": "24 гадз",
    "market.period_7D": "7 дз",
    "market.period_30D": "30 дз"
  },
  de: {
    "market.favourites_title": "Favoriten",
    "market.favourites_empty": "Speichere NFTs auf ihrer Token-Seite, um sie hier zu sehen.",
    "market.auction_active_purchase": "Dieses NFT wird versteigert. Ein regulärer Kauf ist nicht verfügbar.",
    "market.ach_auction_title": "Auktionssiege: {count}",
    "market.ach_auction_desc": "Gewinne {count} Auktionen.",
    "market.ach_auction_source": "Erfolge basieren auf den letzten 20 über die API verfügbaren abgeschlossenen Auktionen.",

    "market.preview_unavailable": "Keine Gebote möglich",

    "market.ranking_name": "Nach Name",
    "market.chart_old_record": "Der letzte Eintrag ist älter als ein Tag. Dies ist kein aktueller Kurs.",
    "market.chart_source": "Quelle: NFT-Preisverlauf aus der Fexsea-API.",
    "market.chart_snapshot": "Preisverlauf zum Zeitpunkt des Seitenladens.",
    "market.chart_current_price": "Aktueller Preis: {amount}. Der letzte Historieneintrag kann vom aktuellen Preis abweichen.",
    "market.chart_last_record": "Letzter Eintrag: {time}",
    "market.chart_period_empty": "Keine Einträge im ausgewählten Zeitraum.",
    "market.chart_invalid_time": "Keine Preise mit gültigen Zeitstempeln.",
    "market.ranking_trending": "Im Trend",
    "market.ranking_volume": "Top nach Volumen",
    "market.ranking_gainers": "Top-Gewinner",
    "market.ranking_new": "Neu",
    "market.time_expired": "abgelaufen",
    "market.time_days_hours": "{days} T. {hours} Std.",
    "market.time_hours_minutes": "{hours} Std. {minutes} Min.",
    "market.time_minutes": "{minutes} Min.",
    "market.time_under_minute": "weniger als eine Minute",
    "market.rarity_legendary": "Legendär",
    "market.rarity_epic": "Episch",
    "market.rarity_rare": "Selten",
    "market.rarity_uncommon": "Ungewöhnlich",
    "market.rarity_common": "Gewöhnlich",
    "market.ach_first_nft_title": "Erstes NFT",
    "market.ach_first_nft_desc": "Kaufen Sie Ihr erstes NFT",
    "market.ach_collector_title": "Sammler",
    "market.ach_collector_desc": "Halten Sie 10 NFTs im Portfolio",
    "market.ach_curator_title": "Kurator",
    "market.ach_curator_desc": "Halten Sie 50 NFTs im Portfolio",
    "market.ach_trader_title": "Trader",
    "market.ach_whale_title": "Wal",
    "market.ach_turnover_desc": "Erreichen Sie einen Umsatz von {amount}",
    "market.ach_level5_title": "Level 5",
    "market.ach_level5_desc": "Erreichen Sie Level 5",
    "market.ach_verified_title": "Verifiziert",
    "market.ach_verified_desc": "Verifizieren Sie Ihr Konto",
    "market.ach_secure_title": "Geschützt",
    "market.ach_secure_desc": "Aktivieren Sie den Zwei-Faktor-Schutz",
    "market.phase_ended": "Auktion beendet",
    "market.phase_starts_in": "beginnt in {time}",
    "market.phase_soon": "beginnt bald",
    "market.phase_left": "noch {time}",
    "market.fact_token_id": "Token-ID",
    "market.fact_blockchain": "Blockchain",
    "market.fact_contract": "Vertragsadresse",
    "market.fact_rarity_rank": "Seltenheitsrang",
    "market.fact_rarity_rank_of": "#{rank} von {supply}",
    "market.fact_rarity_score": "Seltenheitswert",
    "market.facts_unavailable": "Weitere NFT-Details sind derzeit nicht verfügbar.",
    "market.traits": "Attribute",
    "market.trait_fallback": "Attribut",
    "market.trait_share": "{percent} haben dieses Attribut",
    "market.standing_lead": "Ihr Gebot führt",
    "market.standing_outbid": "Sie wurden überboten",
    "market.auctions_server_unavailable": "Diese Auktion ist derzeit nicht verfügbar.",
    "market.bid_required": "Geben Sie einen Gebotsbetrag ein.",
    "market.bid_min_error": "Das Mindestgebot beträgt {amount}.",
    "market.bid_accepted": "Gebot über {amount} angenommen.",
    "market.auction": "Auktion",
    "market.current_bid": "Aktuelles Gebot",
    "market.start_price": "Startpreis",
    "market.min_bid": "Mindestgebot",
    "market.bids_count": "Gebote",
    "market.buy_now": "Sofortkauf",
    "market.your_bid_label": "Ihr Gebot, {currency}",
    "market.bid_min_hint": "Mindestens {amount}",
    "market.place_bid": "Gebot abgeben",
    "market.buy_now_for": "Sofort kaufen für {amount}",
    "market.buy_now_confirm_title": "Dieses Los sofort kaufen?",
    "market.buy_now_confirm_desc": "{amount} werden von Ihrem Guthaben abgebucht, die Auktion endet und das NFT gehört Ihnen.",
    "market.buy_now_confirm": "Jetzt kaufen",
    "market.buy_now_done": "Los gekauft.",
    "market.stats_region": "Kollektionsstatistik",
    "market.floor": "Floor-Preis",
    "market.floor_hint": "Niedrigster Preis unter den angebotenen NFTs",
    "market.volume": "Handelsvolumen",
    "market.volume_hint": "Gesamtes Verkaufsvolumen",
    "market.owners": "Besitzer",
    "market.listed": "Angeboten",
    "market.listed_hint": "Anteil der zum Verkauf angebotenen NFTs",
    "market.supply": "NFTs gesamt",
    "market.floor_chart": "Floor-Preis-Diagramm",
    "market.loading_short": "Wird geladen…",
    "market.stats_unavailable": "Der Verlauf des Mindestpreises ist derzeit nicht verfügbar.",
    "market.floor_history_empty": "Noch keine Floor-Preis-Historie vorhanden.",
    "market.sort_default": "Standard",
    "market.sort_price_asc": "Preis: aufsteigend",
    "market.sort_price_desc": "Preis: absteigend",
    "market.sort_number_asc": "Token-ID: aufsteigend",
    "market.sort_number_desc": "Token-ID: absteigend",
    "market.network_unknown": "Netzwerk nicht angegeben",
    "market.all_collections": "Alle Kollektionen",
    "market.author": "Ersteller: {author}",
    "market.author_unknown": "nicht angegeben",
    "market.items_count": "Objekte",
    "market.you_own": "Ihr Besitz",
    "market.min_price": "Mindestpreis",
    "market.max_price": "Höchstpreis",
    "market.items": "Objekte",
    "market.shown_of": "{shown} von {total}",
    "market.search_token": "Nach Token-ID suchen",
    "market.filters": "Filter",
    "market.all_networks": "Alle Netzwerke",
    "market.price_from": "Preis ab",
    "market.price_to": "Preis bis",
    "market.sort": "Sortierung",
    "market.reset_filters": "Filter zurücksetzen",
    "market.nfts_not_found": "Keine NFTs gefunden",
    "market.nfts_not_found_filtered": "Ändern Sie die Suche oder setzen Sie die Filter zurück.",
    "market.collection_empty": "Diese Kollektion enthält noch keine Objekte.",
    "market.collection_activity": "Kollektionsaktivität",
    "market.own_id_not_returned": "Der NFT-Besitz konnte nicht bestätigt werden. Laden Sie die Seite neu.",
    "market.bought": "Kauf abgeschlossen.",
    "market.listed_done": "NFT zum Verkauf angeboten.",
    "market.unlisted_done": "NFT aus dem Verkauf genommen.",
    "market.profile_refresh_failed": "Der Vorgang war erfolgreich, aber Ihre Profildaten konnten nicht aktualisiert werden. Laden Sie die Seite neu.",
    "market.invalid_price": "Geben Sie einen gültigen Preis ein.",
    "market.fav_removed": "Aus den Favoriten entfernt.",
    "market.fav_added": "Zu den Favoriten hinzugefügt.",
    "market.loading_nft": "NFT wird geladen",
    "market.you_own_badge": "Ihr Besitz",
    "market.on_sale": "Zum Verkauf",
    "market.fav_remove_aria": "Aus den Favoriten entfernen",
    "market.fav_add_aria": "Zu den Favoriten hinzufügen",
    "market.fav_unavailable": "Favoriten nicht verfügbar",
    "market.fav_in": "In den Favoriten",
    "market.fav_to": "Zu Favoriten",
    "market.current_price": "Aktueller Preis",
    "market.sale_price": "Verkaufspreis",
    "market.list_for_sale": "Zum Verkauf anbieten",
    "market.unlist": "Aus dem Verkauf nehmen",
    "market.own_id_missing": "Die Besitz-ID für diesen Vorgang konnte nicht abgerufen werden.",
    "market.buy_for": "Kaufen für {amount}",
    "market.not_for_sale": "Dieses NFT steht derzeit nicht zum Verkauf.",
    "market.confirm_region": "Vorgang bestätigen",
    "market.confirm_buy": "Kauf bestätigen",
    "market.confirm_list": "Angebot bestätigen",
    "market.confirm_unlist": "NFT aus dem Verkauf nehmen?",
    "market.network_unknown_inline": "Netzwerk nicht angegeben",
    "market.executing": "Wird ausgeführt…",
    "market.confirm": "Bestätigen",
    "market.cancel": "Abbrechen",
    "market.price_history": "Preisverlauf",
    "market.price_history_chart": "Preisverlaufsdiagramm",
    "market.price_history_empty": "Der Preisverlauf ist noch nicht verfügbar.",
    "market.nft_activity": "NFT-Aktivität",
    "market.loading_collections": "Kollektionen werden geladen",
    "market.network": "Netzwerk",
    "market.all": "Alle",
    "market.no_collections": "Noch keine Kollektionen",
    "market.no_collections_desc": "Neue Kollektionen erscheinen hier nach ihrer Veröffentlichung.",
    "market.by_author": "Von {author}",
    "market.collections_list": "Kollektionsliste",
    "market.collection": "Kollektion",
    "market.search_aria": "Marktplatz durchsuchen",
    "market.search_clear": "Suche löschen",
    "market.search_results": "Suchergebnisse",
    "market.collections": "Kollektionen",
    "market.searching": "Suche läuft",
    "market.nothing_found": "Nichts gefunden",
    "market.status_active": "Laufend",
    "market.status_active_empty": "Derzeit laufen keine Auktionen.",
    "market.status_upcoming": "Demnächst",
    "market.status_upcoming_empty": "Noch keine anstehenden Auktionen.",
    "market.status_ended": "Beendet",
    "market.status_ended_empty": "Noch keine beendeten Auktionen.",
    "market.auctions_eyebrow": "Auktionen",
    "market.auctions_title": "Auktionen",
    "market.auctions_subtitle": "Bieten Sie auf Lose der Plattform",
    "market.auctions_status_aria": "Auktionsstatus",
    "market.loading_auctions": "Auktionen werden geladen",
    "market.auctions_unavailable_note": "Noch keine Auktionen.",
    "market.empty": "Leer",
    "market.card_bid": "Gebot",
    "market.card_start": "Start",
    "market.card_buyout": "Sofortkauf",
    "market.rankings_eyebrow": "Statistik",
    "market.rankings_title": "Ranglisten",
    "market.rankings_subtitle": "Kollektionen auf dem Marktplatz",
    "market.category_aria": "Kategorie",
    "market.period_aria": "Zeitraum",
    "market.rankings_unavailable": "Handelsstatistiken für die Rangliste sind nicht verfügbar. Der Sammlungskatalog wird angezeigt.",
    "market.loading_ranking": "Rangliste wird geladen",
    "market.rankings_empty_title": "Noch leer",
    "market.rankings_empty_desc": "Keine Kollektionen zum Anzeigen.",
    "market.col_floor": "Mindestpreis",
    "market.col_volume": "Volumen",
    "market.col_change": "Änderung",
    "market.chart_insufficient": "Nicht genügend Daten für ein Diagramm.",
    "market.chart_min": "min. {value}",
    "market.chart_max": "max. {value}",
    "market.period_1H": "1 Std.",
    "market.period_6H": "6 Std.",
    "market.period_24H": "24 Std.",
    "market.period_7D": "7 T.",
    "market.period_30D": "30 T."
  },
  fr: {
    "market.favourites_title": "Favoris",
    "market.favourites_empty": "Ajoutez des NFT aux favoris depuis leur page pour les retrouver ici.",
    "market.auction_active_purchase": "Ce NFT est aux enchères. L’achat classique est indisponible.",
    "market.ach_auction_title": "Enchères remportées : {count}",
    "market.ach_auction_desc": "Remportez {count} enchères.",
    "market.ach_auction_source": "Les succès reposent sur les 20 dernières enchères terminées disponibles via l’API.",

    "market.preview_unavailable": "Enchères indisponibles",

    "market.ranking_name": "Par nom",
    "market.chart_old_record": "La dernière observation date de plus d’un jour. Ce n’est pas une cotation actuelle.",
    "market.chart_source": "Source : historique des prix NFT de l’API Fexsea.",
    "market.chart_snapshot": "Historique des prix au chargement de la page.",
    "market.chart_current_price": "Prix actuel : {amount}. La dernière valeur historique peut différer du prix actuel.",
    "market.chart_last_record": "Dernière observation : {time}",
    "market.chart_period_empty": "Aucune observation sur la période sélectionnée.",
    "market.chart_invalid_time": "Aucun prix avec un horodatage valide.",
    "market.ranking_trending": "Tendances",
    "market.ranking_volume": "Top volume",
    "market.ranking_gainers": "En hausse",
    "market.ranking_new": "Nouveautés",
    "market.time_expired": "expiré",
    "market.time_days_hours": "{days} j {hours} h",
    "market.time_hours_minutes": "{hours} h {minutes} min",
    "market.time_minutes": "{minutes} min",
    "market.time_under_minute": "moins d'une minute",
    "market.rarity_legendary": "Légendaire",
    "market.rarity_epic": "Épique",
    "market.rarity_rare": "Rare",
    "market.rarity_uncommon": "Peu commun",
    "market.rarity_common": "Commun",
    "market.ach_first_nft_title": "Premier NFT",
    "market.ach_first_nft_desc": "Achetez votre premier NFT",
    "market.ach_collector_title": "Collectionneur",
    "market.ach_collector_desc": "Réunissez 10 NFT dans votre portefeuille",
    "market.ach_curator_title": "Curateur",
    "market.ach_curator_desc": "Réunissez 50 NFT dans votre portefeuille",
    "market.ach_trader_title": "Trader",
    "market.ach_whale_title": "Baleine",
    "market.ach_turnover_desc": "Atteignez un volume d'échanges de {amount}",
    "market.ach_level5_title": "Niveau 5",
    "market.ach_level5_desc": "Atteignez le niveau 5",
    "market.ach_verified_title": "Vérifié",
    "market.ach_verified_desc": "Faites vérifier votre compte",
    "market.ach_secure_title": "Protégé",
    "market.ach_secure_desc": "Activez la protection à deux facteurs",
    "market.phase_ended": "enchère terminée",
    "market.phase_starts_in": "commence dans {time}",
    "market.phase_soon": "commence bientôt",
    "market.phase_left": "reste {time}",
    "market.fact_token_id": "ID du jeton",
    "market.fact_blockchain": "Blockchain",
    "market.fact_contract": "Adresse du contrat",
    "market.fact_rarity_rank": "Rang de rareté",
    "market.fact_rarity_rank_of": "#{rank} sur {supply}",
    "market.fact_rarity_score": "Indice de rareté",
    "market.facts_unavailable": "Les détails supplémentaires du NFT sont actuellement indisponibles.",
    "market.traits": "Attributs",
    "market.trait_fallback": "Attribut",
    "market.trait_share": "{percent} possèdent cet attribut",
    "market.standing_lead": "Votre offre est en tête",
    "market.standing_outbid": "Votre offre a été dépassée",
    "market.auctions_server_unavailable": "Cette enchère est actuellement indisponible.",
    "market.bid_required": "Saisissez le montant de l'offre.",
    "market.bid_min_error": "L'offre minimale est de {amount}.",
    "market.bid_accepted": "Offre de {amount} acceptée.",
    "market.auction": "Enchère",
    "market.current_bid": "Offre actuelle",
    "market.start_price": "Prix de départ",
    "market.min_bid": "Offre min.",
    "market.bids_count": "Offres",
    "market.buy_now": "Achat immédiat",
    "market.your_bid_label": "Votre offre, {currency}",
    "market.bid_min_hint": "Minimum {amount}",
    "market.place_bid": "Enchérir",
    "market.buy_now_for": "Acheter immédiatement pour {amount}",
    "market.buy_now_confirm_title": "Acheter ce lot immédiatement ?",
    "market.buy_now_confirm_desc": "{amount} sera débité de votre solde, l'enchère prendra fin et le NFT sera à vous.",
    "market.buy_now_confirm": "Acheter",
    "market.buy_now_done": "Lot acheté.",
    "market.stats_region": "Statistiques de la collection",
    "market.floor": "Prix plancher",
    "market.floor_hint": "Prix le plus bas parmi les NFT en vente",
    "market.volume": "Volume d'échanges",
    "market.volume_hint": "Volume total des ventes",
    "market.owners": "Propriétaires",
    "market.listed": "En vente",
    "market.listed_hint": "Part des NFT mis en vente",
    "market.supply": "Total des NFT",
    "market.floor_chart": "Graphique du prix plancher",
    "market.loading_short": "Chargement…",
    "market.stats_unavailable": "L’historique du prix minimum est actuellement indisponible.",
    "market.floor_history_empty": "Aucun historique du prix plancher pour l'instant.",
    "market.sort_default": "Par défaut",
    "market.sort_price_asc": "Prix : croissant",
    "market.sort_price_desc": "Prix : décroissant",
    "market.sort_number_asc": "ID du jeton : croissant",
    "market.sort_number_desc": "ID du jeton : décroissant",
    "market.network_unknown": "Réseau non indiqué",
    "market.all_collections": "Toutes les collections",
    "market.author": "Créateur : {author}",
    "market.author_unknown": "non indiqué",
    "market.items_count": "Objets",
    "market.you_own": "Vous possédez",
    "market.min_price": "Prix minimum",
    "market.max_price": "Prix maximum",
    "market.items": "Objets",
    "market.shown_of": "{shown} sur {total}",
    "market.search_token": "Rechercher par ID de jeton",
    "market.filters": "Filtres",
    "market.all_networks": "Tous les réseaux",
    "market.price_from": "Prix min.",
    "market.price_to": "Prix max.",
    "market.sort": "Trier par",
    "market.reset_filters": "Réinitialiser les filtres",
    "market.nfts_not_found": "Aucun NFT trouvé",
    "market.nfts_not_found_filtered": "Modifiez votre recherche ou réinitialisez les filtres.",
    "market.collection_empty": "Cette collection ne contient encore aucun objet.",
    "market.collection_activity": "Activité de la collection",
    "market.own_id_not_returned": "Impossible de confirmer la propriété du NFT. Actualisez la page.",
    "market.bought": "Achat effectué.",
    "market.listed_done": "NFT mis en vente.",
    "market.unlisted_done": "NFT retiré de la vente.",
    "market.profile_refresh_failed": "L'opération a réussi, mais les données du profil n'ont pas pu être actualisées. Rechargez la page.",
    "market.invalid_price": "Saisissez un prix valide.",
    "market.fav_removed": "Retiré des favoris.",
    "market.fav_added": "Ajouté aux favoris.",
    "market.loading_nft": "Chargement du NFT",
    "market.you_own_badge": "Vous en êtes propriétaire",
    "market.on_sale": "En vente",
    "market.fav_remove_aria": "Retirer des favoris",
    "market.fav_add_aria": "Ajouter aux favoris",
    "market.fav_unavailable": "Favoris indisponibles",
    "market.fav_in": "Dans les favoris",
    "market.fav_to": "Ajouter aux favoris",
    "market.current_price": "Prix actuel",
    "market.sale_price": "Prix de vente",
    "market.list_for_sale": "Mettre en vente",
    "market.unlist": "Retirer de la vente",
    "market.own_id_missing": "Impossible d'obtenir l'identifiant de propriété pour cette opération.",
    "market.buy_for": "Acheter pour {amount}",
    "market.not_for_sale": "Ce NFT n'est pas en vente actuellement.",
    "market.confirm_region": "Confirmation de l'opération",
    "market.confirm_buy": "Confirmez l'achat",
    "market.confirm_list": "Confirmez la mise en vente",
    "market.confirm_unlist": "Retirer le NFT de la vente ?",
    "market.network_unknown_inline": "réseau non indiqué",
    "market.executing": "Traitement…",
    "market.confirm": "Confirmer",
    "market.cancel": "Annuler",
    "market.price_history": "Historique des prix",
    "market.price_history_chart": "Graphique de l'historique des prix",
    "market.price_history_empty": "L'historique des prix n'est pas encore disponible.",
    "market.nft_activity": "Activité du NFT",
    "market.loading_collections": "Chargement des collections",
    "market.network": "Réseau",
    "market.all": "Tous",
    "market.no_collections": "Aucune collection pour l'instant",
    "market.no_collections_desc": "Les nouvelles collections apparaîtront ici dès leur publication.",
    "market.by_author": "Par {author}",
    "market.collections_list": "Liste des collections",
    "market.collection": "Collection",
    "market.search_aria": "Rechercher sur la place de marché",
    "market.search_clear": "Effacer la recherche",
    "market.search_results": "Résultats de recherche",
    "market.collections": "Collections",
    "market.searching": "Recherche",
    "market.nothing_found": "Aucun résultat",
    "market.status_active": "En cours",
    "market.status_active_empty": "Aucune enchère en cours pour le moment.",
    "market.status_upcoming": "À venir",
    "market.status_upcoming_empty": "Aucune enchère à venir pour l'instant.",
    "market.status_ended": "Terminées",
    "market.status_ended_empty": "Aucune enchère terminée pour l'instant.",
    "market.auctions_eyebrow": "Enchères",
    "market.auctions_title": "Enchères",
    "market.auctions_subtitle": "Enchérissez sur les lots de la plateforme",
    "market.auctions_status_aria": "Statut des enchères",
    "market.loading_auctions": "Chargement des enchères",
    "market.auctions_unavailable_note": "Aucune enchère pour le moment.",
    "market.empty": "Vide",
    "market.card_bid": "Offre",
    "market.card_start": "Départ",
    "market.card_buyout": "Achat immédiat",
    "market.rankings_eyebrow": "Statistiques",
    "market.rankings_title": "Classements",
    "market.rankings_subtitle": "Collections de la plateforme",
    "market.category_aria": "Catégorie",
    "market.period_aria": "Période",
    "market.rankings_unavailable": "Les statistiques de classement sont indisponibles. Le catalogue des collections est affiché.",
    "market.loading_ranking": "Chargement du classement",
    "market.rankings_empty_title": "Rien pour l'instant",
    "market.rankings_empty_desc": "Aucune collection à afficher.",
    "market.col_floor": "Prix min.",
    "market.col_volume": "Volume",
    "market.col_change": "Variation",
    "market.chart_insufficient": "Pas assez de données pour un graphique.",
    "market.chart_min": "min. {value}",
    "market.chart_max": "max. {value}",
    "market.period_1H": "1 h",
    "market.period_6H": "6 h",
    "market.period_24H": "24 h",
    "market.period_7D": "7 j",
    "market.period_30D": "30 j"
  },
  cn: {
    "market.favourites_title": "收藏",
    "market.favourites_empty": "在 NFT 页面添加收藏，即可在此查看。",
    "market.auction_active_purchase": "该 NFT 正在拍卖，暂不支持普通购买。",
    "market.ach_auction_title": "拍卖获胜次数：{count}",
    "market.ach_auction_desc": "赢得 {count} 场拍卖。",
    "market.ach_auction_source": "成就根据 API 提供的最近 20 场已结束拍卖计算。",

    "market.preview_unavailable": "不可竞价",

    "market.ranking_name": "按名称",
    "market.chart_old_record": "最新记录已超过一天，不代表当前报价。",
    "market.chart_source": "来源：Fexsea API 的 NFT 价格历史。",
    "market.chart_snapshot": "截至页面加载时的价格历史。",
    "market.chart_current_price": "当前价格：{amount}。最新历史记录可能与当前价格不同。",
    "market.chart_last_record": "最新记录：{time}",
    "market.chart_period_empty": "所选时间段内没有记录。",
    "market.chart_invalid_time": "暂无带有效时间戳的价格。",
    "market.ranking_trending": "热门",
    "market.ranking_volume": "成交量排行",
    "market.ranking_gainers": "涨幅榜",
    "market.ranking_new": "最新",
    "market.time_expired": "已过期",
    "market.time_days_hours": "{days}天{hours}小时",
    "market.time_hours_minutes": "{hours}小时{minutes}分钟",
    "market.time_minutes": "{minutes}分钟",
    "market.time_under_minute": "不到1分钟",
    "market.rarity_legendary": "传奇",
    "market.rarity_epic": "史诗",
    "market.rarity_rare": "稀有",
    "market.rarity_uncommon": "罕见",
    "market.rarity_common": "普通",
    "market.ach_first_nft_title": "首个NFT",
    "market.ach_first_nft_desc": "购买您的第一个NFT",
    "market.ach_collector_title": "收藏家",
    "market.ach_collector_desc": "在作品集中收藏10个NFT",
    "market.ach_curator_title": "策展人",
    "market.ach_curator_desc": "在作品集中收藏50个NFT",
    "market.ach_trader_title": "交易者",
    "market.ach_whale_title": "巨鲸",
    "market.ach_turnover_desc": "交易额达到 {amount}",
    "market.ach_level5_title": "5级",
    "market.ach_level5_desc": "升至5级",
    "market.ach_verified_title": "已认证",
    "market.ach_verified_desc": "完成账户认证",
    "market.ach_secure_title": "安全守护",
    "market.ach_secure_desc": "开启双重身份验证",
    "market.phase_ended": "拍卖已结束",
    "market.phase_starts_in": "{time}后开始",
    "market.phase_soon": "即将开始",
    "market.phase_left": "剩余{time}",
    "market.fact_token_id": "代币ID",
    "market.fact_blockchain": "区块链",
    "market.fact_contract": "合约地址",
    "market.fact_rarity_rank": "稀有度排名",
    "market.fact_rarity_rank_of": "第{rank}名，共{supply}",
    "market.fact_rarity_score": "稀有度指数",
    "market.facts_unavailable": "暂无更多 NFT 信息。",
    "market.traits": "属性",
    "market.trait_fallback": "属性",
    "market.trait_share": "{percent}拥有此属性",
    "market.standing_lead": "您的出价领先",
    "market.standing_outbid": "您的出价已被超越",
    "market.auctions_server_unavailable": "此拍卖暂不可用。",
    "market.bid_required": "请输入出价金额。",
    "market.bid_min_error": "最低出价为 {amount}。",
    "market.bid_accepted": "出价 {amount} 已受理。",
    "market.auction": "拍卖",
    "market.current_bid": "当前出价",
    "market.start_price": "起拍价",
    "market.min_bid": "最低出价",
    "market.bids_count": "出价次数",
    "market.buy_now": "一口价",
    "market.your_bid_label": "您的出价（{currency}）",
    "market.bid_min_hint": "最低 {amount}",
    "market.place_bid": "出价",
    "market.buy_now_for": "以 {amount} 一口价购买",
    "market.buy_now_confirm_title": "立即一口价购买该拍品？",
    "market.buy_now_confirm_desc": "将从余额中扣除 {amount}，拍卖随即结束，NFT 归您所有。",
    "market.buy_now_confirm": "购买",
    "market.buy_now_done": "拍品已购得。",
    "market.stats_region": "收藏系列统计",
    "market.floor": "地板价",
    "market.floor_hint": "在售NFT中的最低价格",
    "market.volume": "交易量",
    "market.volume_hint": "销售总额",
    "market.owners": "持有人",
    "market.listed": "在售",
    "market.listed_hint": "挂牌出售的NFT占比",
    "market.supply": "NFT总数",
    "market.floor_chart": "地板价走势图",
    "market.loading_short": "加载中…",
    "market.stats_unavailable": "暂无最低价格历史。",
    "market.floor_history_empty": "暂无地板价历史。",
    "market.sort_default": "默认",
    "market.sort_price_asc": "价格：从低到高",
    "market.sort_price_desc": "价格：从高到低",
    "market.sort_number_asc": "代币ID：升序",
    "market.sort_number_desc": "代币ID：降序",
    "market.network_unknown": "未指定网络",
    "market.all_collections": "全部收藏系列",
    "market.author": "创作者：{author}",
    "market.author_unknown": "未注明",
    "market.items_count": "物品数",
    "market.you_own": "您持有",
    "market.min_price": "最低价格",
    "market.max_price": "最高价格",
    "market.items": "物品",
    "market.shown_of": "{shown} / {total}",
    "market.search_token": "按代币ID搜索",
    "market.filters": "筛选",
    "market.all_networks": "全部网络",
    "market.price_from": "最低价",
    "market.price_to": "最高价",
    "market.sort": "排序",
    "market.reset_filters": "重置筛选",
    "market.nfts_not_found": "未找到NFT",
    "market.nfts_not_found_filtered": "请修改搜索条件或重置筛选。",
    "market.collection_empty": "该收藏系列暂无物品。",
    "market.collection_activity": "收藏系列动态",
    "market.own_id_not_returned": "无法确认 NFT 所有权，请刷新页面。",
    "market.bought": "购买成功。",
    "market.listed_done": "NFT已挂牌出售。",
    "market.unlisted_done": "NFT已下架。",
    "market.profile_refresh_failed": "操作已完成，但无法刷新个人资料数据。请刷新页面。",
    "market.invalid_price": "请输入有效价格。",
    "market.fav_removed": "已从收藏中移除。",
    "market.fav_added": "已加入收藏。",
    "market.loading_nft": "正在加载NFT",
    "market.you_own_badge": "您已持有",
    "market.on_sale": "在售",
    "market.fav_remove_aria": "从收藏中移除",
    "market.fav_add_aria": "加入收藏",
    "market.fav_unavailable": "收藏不可用",
    "market.fav_in": "已收藏",
    "market.fav_to": "收藏",
    "market.current_price": "当前价格",
    "market.sale_price": "售价",
    "market.list_for_sale": "挂牌出售",
    "market.unlist": "下架",
    "market.own_id_missing": "无法获取此操作所需的持有ID。",
    "market.buy_for": "以 {amount} 购买",
    "market.not_for_sale": "该NFT目前未出售。",
    "market.confirm_region": "操作确认",
    "market.confirm_buy": "确认购买",
    "market.confirm_list": "确认挂牌",
    "market.confirm_unlist": "确认下架该NFT？",
    "market.network_unknown_inline": "未指定网络",
    "market.executing": "处理中…",
    "market.confirm": "确认",
    "market.cancel": "取消",
    "market.price_history": "价格历史",
    "market.price_history_chart": "价格历史走势图",
    "market.price_history_empty": "暂无价格历史。",
    "market.nft_activity": "NFT动态",
    "market.loading_collections": "正在加载收藏系列",
    "market.network": "网络",
    "market.all": "全部",
    "market.no_collections": "暂无收藏系列",
    "market.no_collections_desc": "新的收藏系列发布后将显示在这里。",
    "market.by_author": "创作者 {author}",
    "market.collections_list": "收藏系列列表",
    "market.collection": "收藏系列",
    "market.search_aria": "搜索市场",
    "market.search_clear": "清除搜索",
    "market.search_results": "搜索结果",
    "market.collections": "收藏系列",
    "market.searching": "搜索中",
    "market.nothing_found": "未找到结果",
    "market.status_active": "进行中",
    "market.status_active_empty": "目前没有进行中的拍卖。",
    "market.status_upcoming": "即将开始",
    "market.status_upcoming_empty": "暂无即将开始的拍卖。",
    "market.status_ended": "已结束",
    "market.status_ended_empty": "暂无已结束的拍卖。",
    "market.auctions_eyebrow": "拍卖",
    "market.auctions_title": "拍卖",
    "market.auctions_subtitle": "对平台拍品出价",
    "market.auctions_status_aria": "拍卖状态",
    "market.loading_auctions": "正在加载拍卖",
    "market.auctions_unavailable_note": "暂无拍卖。",
    "market.empty": "暂无内容",
    "market.card_bid": "出价",
    "market.card_start": "起拍",
    "market.card_buyout": "一口价",
    "market.rankings_eyebrow": "数据",
    "market.rankings_title": "排行榜",
    "market.rankings_subtitle": "平台系列",
    "market.category_aria": "类别",
    "market.period_aria": "时段",
    "market.rankings_unavailable": "排名交易统计暂不可用。当前显示藏品系列目录。",
    "market.loading_ranking": "正在加载排行榜",
    "market.rankings_empty_title": "暂无内容",
    "market.rankings_empty_desc": "暂无可显示的系列。",
    "market.col_floor": "最低价",
    "market.col_volume": "成交量",
    "market.col_change": "涨跌",
    "market.chart_insufficient": "数据不足，无法绘制图表。",
    "market.chart_min": "最低 {value}",
    "market.chart_max": "最高 {value}",
    "market.period_1H": "1小时",
    "market.period_6H": "6小时",
    "market.period_24H": "24小时",
    "market.period_7D": "7天",
    "market.period_30D": "30天"
  }
});
